var WordConditionModel = /** @class */ (function () {
    function WordConditionModel(variableName, variableGroupName, relationType, baseVariableValue, dataSourceCode, realtionVariableValue, variableVersion) {
        this.variableName = variableName;
        this.variableGroupName = variableGroupName;
        this.relationType = relationType;
        this.baseVariableValue = baseVariableValue;
        this.dataSourceCode = dataSourceCode;
        this.realtionVariableValue = realtionVariableValue;
        this.variableVersion = variableVersion;
    }
    return WordConditionModel;
}());
export { WordConditionModel };
